import React, { useRef, useState } from 'react'
import Swal, { SweetAlertOptions } from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import styles from './alert.module.scss'

const MySwal = withReactContent(Swal)

export const ReactAlert = (text: string, options?: SweetAlertOptions) =>
	MySwal.fire({
		title: text,
		position: 'top',
		toast: true,
		showConfirmButton: false,
		customClass: {
			popup: styles.normal,
		},
		timer: 2000,
		...options,
	})

type CopyProps = {
	text: string
	copyButtonText: string
}

const CopyBlock = ({ text, copyButtonText }: CopyProps) => {
	const inputRef = useRef<HTMLInputElement>(null)
	const [copyStatus, setCopyStatus] = useState('')
	const copyText = () => {
		if (text)
			navigator.clipboard
				.writeText(text)
				.then(() => {
					setCopyStatus('Copied!')
				})
				.catch((err) => {
					console.error('Failed to copy: ', err)
					setCopyStatus('Copy failed')
				})
	}

	return (
		<div className={styles.copy}>
			<div className={styles.copyWrap}>
				<input
					type="text"
					value={text}
					className={styles.copyInput}
					readOnly
					ref={inputRef}
					placeholder="Enter text to copy"
				/>
				<button onClick={copyText} className={styles.copyButton}>
					{copyButtonText}
				</button>
			</div>
			<div className={styles.info}>{copyStatus}</div>
		</div>
	)
}

export const CopyAlert = (text: CopyProps['text'], closeText: string, copyButtonText: CopyProps['copyButtonText']) =>
	MySwal.fire({
		title: <CopyBlock text={text} copyButtonText={copyButtonText} />,
		position: 'center',
		showConfirmButton: true,
		confirmButtonText: closeText,
		confirmButtonAriaLabel: closeText,
		customClass: {
			container: styles.container,
		},
	})

type ErrorProps = {
	text: string
	error: string
}

const ErrorBlock = ({ text, error }: ErrorProps) => {
	const [open, setOpen] = useState(false)

	return (
		<div className={styles.error}>
			<h2 className={styles.main}>{text}</h2>
			<button
				className={styles.switch}
				onClick={() => {
					setOpen((state) => !state)
				}}
			>
				{open ? 'Console Error Close' : 'Console Error Open'}
			</button>
			{open && <div className={styles.sub}>{JSON.stringify(error)}</div>}
		</div>
	)
}

/**
 * 하려했던 기능 설명과 에러 응답
 *
 */
export const errorAlert = (
	/** 하려 했던 동작 */
	description: string,
	error: any
) =>
	MySwal.fire({
		title: <ErrorBlock text={description} error={error} />,
		icon: 'error',
		position: 'top',
		showConfirmButton: true,
		customClass: {
			container: styles.container,
		},
	})

const SuccessBlock = ({ text }: { text: string }) => {
	const [open, setOpen] = useState(false)

	return (
		<div className={styles.error}>
			<h2 className={styles.main}>{text}</h2>
		</div>
	)
}

export const successAlert = (
	/** 하려 했던 동작 */
	description: string
) =>
	MySwal.fire({
		title: <SuccessBlock text={description} />,
		icon: 'success',
		position: 'top',
		timer: 3000,
		timerProgressBar: true,
		backdrop: false,

		customClass: {
			container: styles.container,
		},
	})
